module.exports = __webpack_public_path__ + "static/media/Image10.b78ed7c9.png";